import { render, staticRenderFns } from "./ScreenErrorMessage.vue?vue&type=template&id=21c0d7a0"
import script from "./ScreenErrorMessage.vue?vue&type=script&lang=js"
export * from "./ScreenErrorMessage.vue?vue&type=script&lang=js"
import style0 from "./ScreenErrorMessage.vue?vue&type=style&index=0&id=21c0d7a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports